import { render, staticRenderFns } from "./assignTransactionProductDialog.vue?vue&type=template&id=5acac562"
import script from "./assignTransactionProductDialog.vue?vue&type=script&lang=js"
export * from "./assignTransactionProductDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports